import {
  Box,
  Container,
  Link,
  Stack,
  styled,
  SxProps,
  Typography,
} from '@mui/material'

import { useTranslation } from 'react-i18next'
import { ReactComponent as ArrowRightIcon } from './assets/arrow-right-icon.svg'
import { ReactComponent as FileIcon } from './assets/file-icon.svg'

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}))

const FileLinkWrapper = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  width: '100%',
  gap: 10,
  cursor: 'pointer',
  textDecoration: 'none',
  ...theme.typography.subtitle14Up,
  color: theme.palette.text.primary,
  textWrap: 'wrap',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

const links: { label: string; link: string }[] = [
  {
    label: 'Statut',
    link: '/docs/for-investors/260617_Statut_ARBITAS_podf.pdf',
  },
  {
    label: 'Sdělení klíčových informací PIA EUR',
    link: '/docs/sub-fund/KID_FINTECH-ARBITAS_2026-06-26_PIA-EUR.pdf',
  },
  {
    label: 'Veřejná výzva k úpisu investičních akcií PIA CZK',
    link: '/docs/sub-fund/240614_Verejna-vyzva-k-upisu-investicnich-akcii-PIA-CZK.pdf',
  },
  {
    label: 'Veřejná výzva k úpisu investičních akcií PIA EUR',
    link: '/docs/sub-fund/251223_Verejna-vyzva-k-upisu-investicnich-akcii-PIA-EUR.pdf',
  },
  {
    label: 'Veřejná výzva k úpisu investičních akcií VIA EUR',
    link: '/docs/sub-fund/251223_Verejna-vyzva-k-upisu-investicnich-akcii-VIA-EUR.pdf',
  },
]

interface IProps {
  sx?: SxProps
}

export function FundOverview({ sx }: IProps) {
  const { t } = useTranslation('widgets')

  return (
    <Container maxWidth="lg" id="fund-overview" sx={sx}>
      <Wrapper>
        <Stack maxWidth={570} gap={{ xs: 2.5, md: 5 }}>
          <Typography variant="h2">
            {t('main-page.fund-overview.title')}
          </Typography>

          <Typography variant="text18Regular">
            {t('main-page.fund-overview.text')}
          </Typography>
        </Stack>

        <Stack maxWidth={362} gap={{ xs: 2.5, md: 3 }}>
          <Typography variant="subtitle25SemiBold">
            {t('main-page.fund-overview.links.label')}
          </Typography>

          <Stack gap={1}>
            {links.map((link) => (
              <FileLinkWrapper
                href={link.link}
                target="_blank"
                key={link.label}
              >
                <FileIcon />
                {link.label}

                <Box ml="auto">
                  <ArrowRightIcon />
                </Box>
              </FileLinkWrapper>
            ))}
          </Stack>
        </Stack>
      </Wrapper>
    </Container>
  )
}
